<script setup>
import { useProductStore } from '../../pinia/ProductStore'
import { useCartStore } from '../../pinia/CartStore'

const ProductStore = useProductStore()
const CartStore = useCartStore()

CartStore.getCart()
ProductStore.setInitialProduct()
ProductStore.setInitialVariant()
</script>
